
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'
import { IconWarning } from '@ds/icons/IconWarning'

import RatingInfo from '@internal-reviews/components/RatingInfo'
import { trackClick } from '@tracking/events'

import translations from '../../OutOfStock.translations'
import Price from '../Price'
import Title from '../Title'

export default {
  components: {
    RevButton,
    RevIllustration,
    RevTag,
    RatingInfo,
    Title,
    Price,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    ratings: {
      type: Object,
      default: () => ({ reviewsCount: 0, averageRate: 0 }),
    },
  },
  computed: {
    IconWarning: () => IconWarning,
    translations: () => translations,
  },
  methods: {
    onClickCTA() {
      trackClick({
        name: 'see_alternative',
        zone: 'out_of_stock',
      })
    },
  },
}
